import {
  Link,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { formatCurrency, formatDate } from '../helpers/csvValidation';
import { NfseBatch } from '../types/nfse.types';
import { BatchStatusBadge } from './StatusBadge';

interface BatchesTableProps {
  batches: NfseBatch[];
}

const BatchesTable: React.FC<BatchesTableProps> = ({ batches }) => {
  return (
    <TableContainer>
      <Table variant="simple" size="sm">
        <Thead>
          <Tr h="3.5rem">
            <Th textAlign="left" w="80px">
              ID
            </Th>
            <Th textAlign="left" w="150px">
              Data Referência
            </Th>
            <Th textAlign="center" w="80px">
              Qtd
            </Th>
            <Th textAlign="right" w="120px">
              Total
            </Th>
            <Th textAlign="center" w="120px">
              Status
            </Th>
            <Th textAlign="center" w="100px">
              Criado em
            </Th>
            <Th textAlign="center" w="100px">
              Ações
            </Th>
          </Tr>
        </Thead>

        <Tbody>
          {batches.map((batch) => (
            <Tr key={batch.id} _hover={{ bg: 'gray.50' }}>
              <Td>
                <Link
                  as={RouterLink}
                  to={`/financeiro/lote/${batch.id}`}
                  color="yooga.500"
                  fontWeight="medium"
                >
                  {batch.id}
                </Link>
              </Td>
              <Td>{formatDate(batch.referenceDate)}</Td>
              <Td textAlign="center">{batch.quantity}</Td>
              <Td textAlign="right">{formatCurrency(batch.totalValue)}</Td>
              <Td textAlign="center">
                <BatchStatusBadge status={batch.status} />
              </Td>
              <Td textAlign="center">{formatDate(batch.createdAt)}</Td>
              <Td textAlign="center">
                <Link
                  as={RouterLink}
                  to={`/financeiro/lote/${batch.id}`}
                  color="yooga.500"
                >
                  Ver
                </Link>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
};

export default BatchesTable;
